// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

export var layout = {
  cornerRadius0: 0,
  cornerRadius1: 4,
  cornerRadius2: 8,
  cornerRadius3: 12,
  cornerRadius4: 16,
  cornerRadius5: 20,
  cornerRadius6: 24,
  cornerRadius7: 28,
  cornerRadius8: 32,
  size0: 0,
  size1: 4,
  size2: 8,
  size3: 12,
  size4: 16,
  size5: 20,
  size6: 24,
  size7: 28,
  size8: 32,
  breakpoint0: 575,
  breakpoint1: 576,
  breakpoint2: 767,
  breakpoint3: 768,
  breakpoint4: 991,
  breakpoint5: 992,
  breakpoint6: 1199,
  breakpoint7: 1200
};
export var color = {
  electricBlue0: '#e4eefa',
  electricBlue1: '#c9e0fc',
  electricBlue2: '#b2d2ff',
  electricBlue3: '#8fbaff',
  electricBlue4: '#6fa5ff',
  electricBlue5: '#5492ff',
  electricBlue6: '#296ef9',
  electricBlue7: '#024ad8',
  electricBlue8: '#0036c4',
  electricBlue9: '#001cb0',
  electricBlue10: '#0000a2',
  electricBlue11: '#000083',
  electricBlue12: '#001070',
  powerStorm0: '#dbeff7',
  orangeBloom0: '#fbe5e4',
  orangeBloom1: '#f9d4d2',
  orangeBloom2: '#ffb4b2',
  orangeBloom3: '#fc9292',
  orangeBloom4: '#fd7370',
  orangeBloom5: '#ff5050',
  orangeBloom6: '#e54041',
  orangeBloom7: '#cc2d32',
  orangeBloom8: '#b3262b',
  orangeBloom9: '#941f22',
  orangeBloom10: '#79191b',
  orangeBloom11: '#5a1313',
  orangeBloom12: '#4b0b0c',
  powerStorm1: '#bce2f0',
  powerStorm2: '#a4d3e5',
  powerStorm3: '#8ebdce',
  powerStorm4: '#7fadbe',
  powerStorm5: '#6d9aab',
  powerStorm6: '#568393',
  powerStorm7: '#447180',
  powerStorm8: '#356373',
  powerStorm9: '#235262',
  powerStorm10: '#0e4353',
  powerStorm11: '#003342',
  powerStorm12: '#002935',
  red0: '#faeceb',
  red1: '#ffdbd9',
  red2: '#ffc1bd',
  red3: '#ffa59e',
  red4: '#ff8373',
  red5: '#ff6a4d',
  red6: '#ff3900',
  red7: '#cc2c00',
  red8: '#9f2301',
  red9: '#802208',
  red10: '#68240f',
  red11: '#522112',
  red12: '#422016',
  green0: '#defff1',
  green1: '#ccffe8',
  green2: '#a3ffd6',
  green3: '#78ffc2',
  green4: '#4ef5ab',
  green5: '#00d072',
  green6: '#009955',
  green7: '#007d48',
  green8: '#006c3e',
  green9: '#005a35',
  green10: '#034c2e',
  green11: '#07412a',
  green12: '#093021',
  gray0: '#fafafa',
  gray1: '#f5f5f5',
  gray2: '#f0f0f0',
  gray3: '#e0e0e0',
  gray4: '#c2c2c2',
  gray5: '#a3a3a3',
  gray6: '#858585',
  gray7: '#666666',
  gray8: '#525252',
  gray9: '#3d3d3d',
  gray10: '#292929',
  gray11: '#212121',
  gray12: '#1a1a1a',
  black: '#000000',
  white: '#ffffff',
  highContrastYellow: '#fff700',
  opacity0: 0,
  salmon0: '#f7eeed',
  darkOrange0: '#ffedde',
  darkOrange1: '#ffdbb2',
  darkOrange2: '#ffc98c',
  darkOrange3: '#ffb866',
  darkOrange4: '#ffa238',
  darkOrange5: '#ff8900',
  darkOrange6: '#e07200',
  darkOrange7: '#b2600c',
  darkOrange8: '#874e14',
  darkOrange9: '#6e4318',
  darkOrange10: '#5c3a19',
  darkOrange11: '#4a3016',
  darkOrange12: '#382514',
  salmon1: '#ffe8e5',
  salmon2: '#ffdedb',
  salmon3: '#ffccc7',
  salmon4: '#ffb4ad',
  salmon5: '#ff948a',
  salmon6: '#de7066',
  salmon7: '#a15850',
  salmon8: '#754844',
  salmon9: '#5c3b37',
  salmon10: '#4d312e',
  salmon11: '#402b29',
  salmon12: '#362625',
  bronze0: '#f7f0e3',
  bronze1: '#ffeac7',
  bronze2: '#fae1b6',
  bronze3: '#f0d19e',
  bronze4: '#e5bf7e',
  bronze5: '#d6ab63',
  bronze6: '#b0873f',
  bronze7: '#856630',
  bronze8: '#664e26',
  bronze9: '#52401f',
  bronze10: '#42341a',
  bronze11: '#3b2f1a',
  bronze12: '#302717',
  tangerine0: '#f7edda',
  tangerine1: '#ffe7b8',
  tangerine2: '#ffdb94',
  tangerine3: '#ffcc69',
  tangerine4: '#ffbd3b',
  tangerine5: '#e09600',
  tangerine6: '#b27d12',
  tangerine7: '#8f6c24',
  tangerine8: '#735822',
  tangerine9: '#5c4821',
  tangerine10: '#4f3e20',
  tangerine11: '#42341b',
  tangerine12: '#332916',
  gold0: '#f7f2cb',
  gold1: '#fff29e',
  gold2: '#ffe970',
  gold3: '#ffe137',
  gold4: '#f9d300',
  gold5: '#e5c300',
  gold6: '#bc9f00',
  gold7: '#877300',
  gold8: '#736100',
  gold9: '#5c4e00',
  gold10: '#544700',
  gold11: '#413700',
  gold12: '#302900',
  lime0: '#e8f5c4',
  lime1: '#f0ffc7',
  lime2: '#e1ff90',
  lime3: '#d3fb66',
  lime4: '#bce05a',
  lime5: '#a1bf50',
  lime6: '#80993d',
  lime7: '#627332',
  lime8: '#54632d',
  lime9: '#48532a',
  lime10: '#3e4727',
  lime11: '#373d25',
  lime12: '#272b1d',
  chartreuse0: '#dbf7d0',
  chartreuse1: '#deffd1',
  chartreuse2: '#c3ffab',
  chartreuse3: '#a2ff7d',
  chartreuse4: '#83f955',
  chartreuse5: '#6acc44',
  chartreuse6: '#529e34',
  chartreuse7: '#3f7829',
  chartreuse8: '#366325',
  chartreuse9: '#2e5121',
  chartreuse10: '#28421f',
  chartreuse11: '#24371c',
  chartreuse12: '#202e1a',
  hunterGreen0: '#e0f5df',
  hunterGreen1: '#d6ffd4',
  hunterGreen2: '#aaffa3',
  hunterGreen3: '#8bf684',
  hunterGreen4: '#5ee854',
  hunterGreen5: '#43cc39',
  hunterGreen6: '#29a321',
  hunterGreen7: '#087a00',
  hunterGreen8: '#116108',
  hunterGreen9: '#0b4f06',
  hunterGreen10: '#0c4208',
  hunterGreen11: '#0b3608',
  hunterGreen12: '#0a2b08',
  vividSkyBlue0: '#d7f4f7',
  vividSkyBlue1: '#d4fbff',
  vividSkyBlue2: '#bcf7ff',
  vividSkyBlue3: '#8aefff',
  vividSkyBlue4: '#40defa',
  vividSkyBlue5: '#2ac5e0',
  vividSkyBlue6: '#2796a8',
  vividSkyBlue7: '#187585',
  vividSkyBlue8: '#176673',
  vividSkyBlue9: '#16555f',
  vividSkyBlue10: '#15474f',
  vividSkyBlue11: '#173e45',
  vividSkyBlue12: '#142c30',
  hpBlue0: '#e6f0f5',
  hpBlue1: '#ceeffe',
  hpBlue2: '#b7e8fe',
  hpBlue3: '#9fe0fe',
  hpBlue4: '#73cffe',
  hpBlue5: '#3bb7f6',
  hpBlue6: '#0096d6',
  hpBlue7: '#0073a8',
  hpBlue8: '#015985',
  hpBlue9: '#02476b',
  hpBlue10: '#0a3b54',
  hpBlue11: '#0e3245',
  hpBlue12: '#112d3b',
  cornFlowerBlue0: '#e5f4ff',
  cornFlowerBlue1: '#d1e7ff',
  cornFlowerBlue2: '#b2d8ff',
  cornFlowerBlue3: '#94c9ff',
  cornFlowerBlue4: '#70b5ff',
  cornFlowerBlue5: '#549ef7',
  cornFlowerBlue6: '#3587f2',
  cornFlowerBlue7: '#165dba',
  cornFlowerBlue8: '#114a94',
  cornFlowerBlue9: '#0e3d7a',
  cornFlowerBlue10: '#0b3061',
  cornFlowerBlue11: '#092952',
  cornFlowerBlue12: '#072242',
  royalBlue0: '#e9eff7',
  royalBlue1: '#e5eaff',
  royalBlue2: '#d6ddff',
  royalBlue3: '#c3cdff',
  royalBlue4: '#a7b4ff',
  royalBlue5: '#8190ff',
  royalBlue6: '#6374fd',
  royalBlue7: '#4759f5',
  royalBlue8: '#3543c0',
  royalBlue9: '#2c3798',
  royalBlue10: '#28307b',
  royalBlue11: '#262b65',
  royalBlue12: '#22254d',
  darkNavy0: '#ededf7',
  darkNavy1: '#e5e5ff',
  darkNavy2: '#dbddff',
  darkNavy3: '#ced0fd',
  darkNavy4: '#bbbdfb',
  darkNavy5: '#a2a5fb',
  darkNavy6: '#7c80f4',
  darkNavy7: '#4d52e5',
  darkNavy8: '#3e41b8',
  darkNavy9: '#2d2f86',
  darkNavy10: '#272968',
  darkNavy11: '#212250',
  darkNavy12: '#212248',
  lavender0: '#f0eff7',
  lavender1: '#ebe8ff',
  lavender2: '#e4e0ff',
  lavender3: '#d2ccff',
  lavender4: '#c4bdff',
  lavender5: '#a89efa',
  lavender6: '#8880cf',
  lavender7: '#6a62a3',
  lavender8: '#504a78',
  lavender9: '#3f3b5c',
  lavender10: '#36324a',
  lavender11: '#2d2b3d',
  lavender12: '#292735',
  mediumOrchid0: '#f2ebf7',
  mediumOrchid1: '#f3e0ff',
  mediumOrchid2: '#edd1ff',
  mediumOrchid3: '#e7c2ff',
  mediumOrchid4: '#d9a3fe',
  mediumOrchid5: '#ca7aff',
  mediumOrchid6: '#b655f5',
  mediumOrchid7: '#8c3ebf',
  mediumOrchid8: '#6f3297',
  mediumOrchid9: '#5b2d7a',
  mediumOrchid10: '#4c2963',
  mediumOrchid11: '#3f2550',
  mediumOrchid12: '#342240',
  fuchsia0: '#f7eaf7',
  fuchsia1: '#ffe3ff',
  fuchsia2: '#ffd1ff',
  fuchsia3: '#ffb5ff',
  fuchsia4: '#ff84ff',
  fuchsia5: '#e070e0',
  fuchsia6: '#bf62bf',
  fuchsia7: '#964e96',
  fuchsia8: '#733e73',
  fuchsia9: '#5c355c',
  fuchsia10: '#4a2e4a',
  fuchsia11: '#3d283d',
  fuchsia12: '#332433',
  hotPink0: '#f7ebf1',
  hotPink1: '#ffe3f3',
  hotPink2: '#ffd1eb',
  hotPink3: '#ffbae1',
  hotPink4: '#ff8ece',
  hotPink5: '#ff63bb',
  hotPink6: '#d94e9c',
  hotPink7: '#a8417b',
  hotPink8: '#7f345f',
  hotPink9: '#672f4f',
  hotPink10: '#542a42',
  hotPink11: '#452638',
  hotPink12: '#38232f',
  maroon0: '#f7ebee',
  maroon1: '#ffe3eb',
  maroon2: '#ffd1e0',
  maroon3: '#febacf',
  maroon4: '#fe93b5',
  maroon5: '#fa6996',
  maroon6: '#e54577',
  maroon7: '#c22757',
  maroon8: '#9b1741',
  maroon9: '#851538',
  maroon10: '#69132e',
  maroon11: '#571027',
  maroon12: '#4b0f22',
  warmGray0: '#f2f0f1',
  warmGray1: '#ede8ea',
  warmGray2: '#ebe1e4',
  warmGray3: '#ded3d6',
  warmGray4: '#cfbfc3',
  warmGray5: '#bca9ae',
  warmGray6: '#9c868c',
  warmGray7: '#7a666b',
  warmGray8: '#5c4d50',
  warmGray9: '#483c3f',
  warmGray10: '#3a3133',
  warmGray11: '#2e2829',
  warmGray12: '#231f20',
  opacity1: 10,
  opacity2: 20,
  opacity3: 30,
  opacity4: 40,
  opacity5: 50,
  opacity6: 60,
  opacity7: 70,
  opacity8: 80,
  opacity9: 90,
  highContrastPink: '#fe6aff',
  highContrastBlue: '#00d3ff',
  highContrastGray: '#adadad',
  highContrastEigengrau: '#16141d'
};
export var typography = {
  family0: "'Forma DJR UI', Arial, sans-serif",
  size0: '12px',
  size1: '14px',
  size2: '16px',
  size3: '18px',
  size4: '20px',
  size5: '24px',
  size6: '28px',
  size7: '32px',
  size8: '36px',
  size9: '40px',
  size10: '56px',
  size11: '72px',
  lineHeight0: '12px',
  lineHeight1: '16px',
  lineHeight2: '20px',
  lineHeight3: '24px',
  lineHeight4: '28px',
  lineHeight5: '32px',
  lineHeight6: '36px',
  lineHeight7: '40px',
  lineHeight8: '44px',
  lineHeight9: '48px',
  lineHeight10: '64px',
  lineHeight11: '84px',
  weight0: 100,
  weight1: 200,
  weight2: 300,
  weight3: 400,
  weight4: 500,
  weight5: 600,
  weight6: 700,
  weight7: 800,
  weight8: 900
};
export var elevation = {
  offset0: 0,
  offset1: 0.25,
  offset2: 0.5,
  offset3: 0.75,
  offset4: 1,
  offset5: 1.25,
  offset6: 1.5,
  offset7: 1.75,
  offset8: 2,
  offset9: 2.25,
  offset10: 2.5,
  offset11: 2.75,
  offset12: 3,
  offset13: 3.25,
  offset14: 3.5,
  offset15: 3.75,
  offset16: 4,
  offset17: 4.25,
  offset18: 4.5,
  offset19: 4.75,
  offset20: 5,
  offset21: 5.25,
  offset22: 5.5,
  offset23: 5.75,
  offset24: 6,
  spread0: 0,
  spread1: 0.25,
  spread2: 0.5,
  spread3: 0.75,
  spread4: 1,
  spread5: 1.25,
  spread6: 1.5,
  spread7: 1.75,
  spread8: 2,
  spread9: 2.25,
  spread10: 2.5,
  spread11: 2.75,
  spread12: 3,
  spread13: 3.25,
  spread14: 3.5,
  spread15: 3.75,
  spread16: 4,
  spread17: 4.25,
  spread18: 4.5,
  spread19: 4.75,
  spread20: 5,
  spread21: 5.25,
  spread22: 5.5,
  spread23: 5.75,
  spread24: 6,
  blur0: 0,
  blur1: 1,
  blur2: 2,
  blur3: 3,
  blur4: 4,
  blur5: 5,
  blur6: 6,
  blur7: 7,
  blur8: 8,
  blur9: 9,
  blur10: 10,
  blur11: 11,
  blur12: 12,
  blur13: 13,
  blur14: 14,
  blur15: 15,
  blur16: 16,
  blur17: 17,
  blur18: 18,
  blur19: 19,
  blur20: 20,
  blur21: 21,
  blur22: 22,
  blur23: 23,
  blur24: 24
};
var primitives = {
  layout: layout,
  color: color,
  typography: typography,
  elevation: elevation
};
export default primitives;